import { DEFAULT_USER_IMPLEMENTATION_SETTINGS } from "../../../../components";
import { IUserImplementationSettings, useSettings } from "../../../../hooks";

const useUserImplementationSettings = (userGuid: string) => {
  const {
    userImplementationSettings: { [userGuid]: unsafeSettings },
    updateUserImplementationSettings,
  } = useSettings();

  const safeSettings: IUserImplementationSettings = {
    ...DEFAULT_USER_IMPLEMENTATION_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserImplementationSettings>) => {
      updateUserImplementationSettings(userGuid, updatedSettings);
    },
  };
};

export { useUserImplementationSettings };
